import React, { useState, useMemo, useEffect } from 'react';
import { Container, Button, Grid, Input, Icon, Dropdown, Form, Step, Segment, Table, Message, DropdownItemProps, Checkbox, Loader, Divider } from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { NavLink } from 'react-router-dom';
import StripeApi from '../api/StripeApi';
import { ISpecialEventCategory } from '../Models/ISpecialEventCategory';
import SpecialEventsApi from '../api/SpecialEventsApi';
import dayjs from 'dayjs';
import 'dayjs/locale/fr'; // import locale
import { ISpecialEventBookings } from '../Models/ISpecialEventBookings';
import { ISpecialEventOption } from '../Models/ISpecialEventOptions';

dayjs.locale('fr');

const maxHoursBeforeLockingBookings = 48;

const urlParams = new URLSearchParams(document.location.search);
const currentAction = urlParams.get('action');
const bookingId = !!currentAction ? urlParams.get('id') : undefined;

interface ReservationEvenementSpecialProperties {
  eventCategoryCode: string;
  eventId?: string;
}

const seApi = new SpecialEventsApi();

const ReservationEvenementSpecial = (props: ReservationEvenementSpecialProperties) => {
  const { eventCategoryCode } = props;
  //const currentAction = document.location.hash && document.location.hash.indexOf('?action=') > 0 ? document.location.hash.split('?action=').pop() : null;
  const initStep = useMemo<number>(() => {
    let s = 1;
    //let bookingId = undefined;
    if (currentAction) {
      if (currentAction.indexOf("payment_success") === 0) {
        s = 4;
        //let idxBookingId = document.location.hash.indexOf('&id=');
        //if (idxBookingId > 0) bookingId = document.location.hash.substr(idxBookingId + 4);
      }
      else if (currentAction.indexOf("cancel") === 0) {
        s = 5;
      }
    }
    return s;
  }, []);

  const [step, setStep] = useState<number>(initStep);
  const [selectedMonth, setSelectedMonth] = useState<string>();
  const [selectedDate, setSelectedDate] = useState<string>();
  const [selectedEvent, setSelectedEvent] = useState<ISpecialEventOption>();
  const [zipCode, setZipCode] = useState<string>(document.location.hostname === 'localhost' ? '93160' : '');
  const [firstName, setFirstName] = useState<string>(document.location.hostname === 'localhost' ? 'Gaetan' : '');
  const [lastName, setLastName] = useState<string>(document.location.hostname === 'localhost' ? 'Test' : '');
  const [email, setEmail] = useState<string>(document.location.hostname === 'localhost' ? 'test@fermerainbow.com' : '');
  const emailIsValid = useMemo<boolean>(() => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }, [email]);
  const [verificationEmail, setVerificationEmail] = useState<string>(document.location.hostname === 'localhost' ? 'test@fermerainbow.com' : '');
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [seats, setSeats] = useState<number>(0);
  const [stripe, setStripe] = useState<Stripe | null>();
  const [step2IsValid, setStep2IsValid] = useState<boolean>(false);
  const [proceedingToPayment, setProceedingToPayment] = useState<boolean>(false);
  const [displayEmailError, setDisplayEmailError] = useState<boolean>(false);
  const [displayVerificationEmailError, setDisplayVerificationEmailError] = useState<boolean>(false);
  const [displayZipCodeError, setDisplayZipCodeError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [validatedCGV, setValidatedCGV] = useState<boolean>(false);
  const [loadingAvailability, setLoadingAvailability] = useState<boolean>(false);

  const [specialEventCategory, setSpecialEventCategory] = useState<ISpecialEventCategory>();
  const [specialEventBookings, setSpecialEventBookings] = useState<ISpecialEventBookings[]>();

  const executeScroll = () => {
    const elt = document.getElementById('reservation-evenement-special');
    if (elt) elt.scrollIntoView();
  }

  const stepTitle = useMemo(() => {
    switch (step) {
      case 1:
        return "Date et coordonnées";
      case 2:
        return "Récapitulatif de la commande";
      case 3:
        return "Commande validée";
      case 4:
        return "Commande annulée";
    }
  }, [step]);

  useEffect(() => {
    if (!specialEventCategory && eventCategoryCode) {
      seApi.getCategoryDetails(eventCategoryCode)
        .then((cat) => {
          setSpecialEventCategory(cat.data);
        })
        .catch(() => {
          setErrorMessage('Cet événement est inconnu');
        })
    }
  }, [specialEventCategory, eventCategoryCode]);

  const selectedEVentCategoryDisplayDate = useMemo(() => {
    if (specialEventCategory) {
      const minutes = specialEventCategory.duration % 60;
      const hours = (specialEventCategory.duration - minutes) / 60;
      return `${hours > 0 ? `${hours}h` : ''}${minutes > 0 ? `${minutes}` : ''}${minutes > 0 && hours === 0 ? `mn` : ''}`;
    }
    else
      return '';
  }, [specialEventCategory]);

  const availableMonths = useMemo(() => {
    let months: Date[] = [];
    if (specialEventCategory) {

      months = specialEventCategory.events
        .map(r => r.eventDate.substr(0, 7))
        .filter((val, idx, arr) => arr.indexOf(val) === idx)
        .map(r => {
          const day = new Date(r + '-01');
          return day;
        });
    }
    return months;
  }, [specialEventCategory]);

  const visitMonthOptions = useMemo(() => {
    let options: DropdownItemProps[] = [];
    if (availableMonths) {
      options = availableMonths
        .map((m, i) => {
          const day = dayjs(m)
          return {
            text: day.format('MMMM YYYY'),
            value: day.format('YYYY/MM'),
            key: i,
          };
        });
    }
    return options;
  }, [availableMonths]);

  const availableDays = useMemo(() => {
    let days: ISpecialEventOption[] = [];
    if (specialEventCategory && selectedMonth && specialEventBookings) {
      const selMonthFormated = selectedMonth.replace('/', '-');
      days = specialEventCategory.events.filter(e => e.eventDate.indexOf(selMonthFormated) === 0)
        .map(r => {
          const start = dayjs(r.eventDate);
          const end = start.add(specialEventCategory.duration, 'minute');

          const maxSeats = r.quotaOverride ? r.quotaOverride : specialEventCategory.quotaPerEvent;
          const curBookingsInfo = specialEventBookings ? specialEventBookings.find(b => b.id === r.id) : undefined;
          const curBookings = curBookingsInfo ? curBookingsInfo.count : 0;
          const availableSeats = maxSeats - curBookings;

          return {
            maxSeats,
            availableSeats,
            start: start.toDate(),
            end: end.toDate(),
            id: r.id,
          };
        });
    }
    return days.filter(r => (r.availableSeats < r.maxSeats || dayjs(r.start).diff(dayjs(), 'hours') > maxHoursBeforeLockingBookings));
  }, [specialEventCategory, specialEventBookings, selectedMonth]);

  const visitDayOptions = useMemo(() => {
    let options: DropdownItemProps[] = [];
    if (availableDays) {
      options = availableDays.map(r => {
        const available = r.availableSeats > 0;
        const plural = r.availableSeats > 1 ? "s" : "";

        return {
          text: `${dayjs(r.start).format('dddd DD MMMM YYYY HH:mm')} - ${dayjs(r.end).format('HH:mm')} (${r.availableSeats} place${plural} restante${plural})`,
          value: r.id, // start.format('YYYY/MM/DD HH:mm'),
          key: `${r.id}|${r.availableSeats}`,
          disabled: !available,
          icon: available ? 'calendar' : 'delete calendar',
        } as DropdownItemProps;
      });
    }
    return options;
  }, [availableDays]);

  const bookingSeatsOptions = useMemo(() => {
    let options: DropdownItemProps[] = [];
    if (selectedEvent) {

      if (selectedEvent.availableSeats === selectedEvent.maxSeats && dayjs(selectedEvent.start).diff(dayjs(), 'hours') <= maxHoursBeforeLockingBookings)
        return [{ text: '-', value: 0, disabled: false }];

      for (let i = 0; i <= selectedEvent.maxSeats; i++) {
        options.push({
          text: i,
          value: i,
          disabled: i > selectedEvent.availableSeats
        });
      }
    }
    return options;
  }, [selectedEvent]);

  useEffect(() => {
    if (!stripe) {
      const stripeApi = new StripeApi();
      stripeApi.getPublicKey().then((res) => {
        loadStripe(res.data)
          .then((res) => {
            setStripe(res);
          });
      });
    }
  }, [stripe]);

  useEffect(() => {
    if (eventCategoryCode && selectedMonth) {
      setLoadingAvailability(true);
      const startMonth = dayjs(`${selectedMonth}/01`);
      const endMonth = startMonth.add(1, 'month');
      seApi.getCategoryEventBookings(eventCategoryCode, `${selectedMonth}/01`, endMonth.format("YYYY/MM/DD"))
        .then((res) => {
          setSpecialEventBookings(res.data);
        })
        .catch(() => {
          setSpecialEventBookings([]);
        })
        .finally(() => {
          setLoadingAvailability(false);
        });
    }
  }, [eventCategoryCode, selectedMonth]);

  useEffect(() => {
    if (selectedEvent && seats > 0 && lastName && firstName && zipCode && zipCode.trim().length === 5 && emailIsValid && verificationEmail === email) {
      return setStep2IsValid(true);
    }
    else {
      return setStep2IsValid(false);
    }
  }, [selectedEvent, seats, lastName, firstName, zipCode, email, verificationEmail, emailIsValid]);

  const proceedToPayment = async (ev: any) => {
    // Block native form submission.
    ev.preventDefault();

    setProceedingToPayment(true);
    if (!stripe) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    if (!selectedEvent) return;

    // Create a new Checkout Session using the server-side endpoint
    const stripeApi = new StripeApi();
    stripeApi.createSpecialEventSession({
      Id: uuidv4(),
      EventId: selectedEvent.id,
      EventDate: selectedEvent.start,
      Lastname: lastName,
      FirstName: firstName,
      Email: email,
      Phone: phoneNumber,
      ZipCode: zipCode,
      Seats: seats,
    })
      .then((session) => {
        return stripe.redirectToCheckout({ sessionId: session.data.id });
      })
      .then(function (result) {
        // If `redirectToCheckout` fails due to a browser or network
        // error, you should display the localized error message to your
        // customer using `error.message`.
        if (result.error) {
          setErrorMessage(result.error.message);
          setProceedingToPayment(false);
        }
      })
      .catch(function (error) {
        let errorMsg = error.message;
        if (error.response) {
          if (error.response.status === 404) {
            errorMsg = "Il semblerait qu'il n'y ait plus de place disponible, une réservation a sans doute eu lieu à l'instant."
          }
        }

        setErrorMessage(errorMsg)
        console.error('Error:', errorMsg);
        setProceedingToPayment(false);
      });
  };

  return (
    <Container fluid>
      {specialEventCategory && (<>
        <h3>{specialEventCategory.title}</h3>
        <Segment>
          {specialEventCategory.description && <div>{specialEventCategory.description}</div>}
          <div>Durée: <b>{selectedEVentCategoryDisplayDate}</b></div>
          <div>Tarif ({specialEventCategory.seatUnit ? specialEventCategory.seatUnit : 'par personne'}): <b>{specialEventCategory.unitPrice} &euro;</b></div>
        </Segment>
        {step <= 2 && (
          <Step.Group widths="three" size="tiny">
            <Step active={step === 1} icon="ticket" title="Date et coordonnées" completed={step > 1} />
            <Step active={step === 2} completed={step === 4} icon="payment" title="Récapitulatif et paiement" />
          </Step.Group>
        )}
        <h4>{stepTitle}</h4>
        {visitMonthOptions.length === 0 && step === 1 && (
          <Message negative={true}>Il n'y a aucun créneau de réservation actuellement.</Message>
        )}
        {visitMonthOptions && visitMonthOptions.length > 0 && step === 1 && (
          <React.Fragment>
            <Grid stackable>
              <Grid.Row columns="2">
                <Grid.Column><label>Sélectionnez le mois</label>
                  <Dropdown
                    placeholder='Sélectionnez le mois'
                    fluid
                    selection
                    key="visitMonthChoice"
                    value={selectedMonth}
                    onChange={(e, data) => { setSelectedMonth(data.value as string); setSelectedDate(undefined); }}
                    options={visitMonthOptions}
                  />
                </Grid.Column>
                <Grid.Column>
                  <label>Sélectionnez la date et le créneau horaire *</label>
                  {loadingAvailability ? (
                    <Segment textAlign='center'>
                      <Loader active inline size='small' />
                      Chargement des disponibilités...
                    </Segment>
                  ) : (
                    <Dropdown
                      placeholder="Sélectionnez la date et l'heure"
                      fluid
                      selection
                      key="visitDateChoice"
                      value={selectedDate}
                      onChange={(e, data) => {
                        setSelectedDate(data.value as string);
                        const selDay = availableDays.find(d => d.id === data.value as string);
                        if (selDay) {
                          setSelectedEvent(selDay);
                          if (selDay.availableSeats === selDay.maxSeats && dayjs(selDay.start).diff(dayjs(), 'hours') <= maxHoursBeforeLockingBookings)
                            setSeats(0);
                          else if (seats === 0)
                            setSeats(1);
                        }
                        else
                          setSelectedEvent(undefined);
                      }}
                      options={visitDayOptions}
                    />
                  )}
                </Grid.Column>
              </Grid.Row>
              { selectedEvent && selectedEvent.maxSeats > 1 && (
                <Grid.Row columns="2">
                  <Grid.Column>
                    <label>Sélectionnez le nombre de places *</label>
                    <Dropdown
                      placeholder="Nombre de places"
                      fluid
                      selection
                      key="bookingSeats"
                      value={seats}
                      onChange={(e, data) => {
                        const curVal = data.value as number;
                        if (curVal <= (selectedEvent ? selectedEvent.availableSeats : 0)) {
                          setSeats(data.value as number);
                        }
                      }}
                      options={bookingSeatsOptions}
                    />
                  </Grid.Column>
                </Grid.Row>
              )}
            </Grid>
            <Divider horizontal>Coordonnées</Divider>
            <Form>
              <Form.Group widths="equal">
                <Form.Field required>
                  <label>Nom</label>
                  <Input value={lastName} key="lastName" onChange={(ev, { value }) => { setLastName(value); }} />
                </Form.Field>
                <Form.Field required>
                  <label>Prénom</label>
                  <Input value={firstName} key="firstName" onChange={(ev, { value }) => { setFirstName(value); }} />
                </Form.Field>
                <Form.Field required>
                  <label>Code Postal</label>
                  <Input value={zipCode} key="zipCode" maxLength="5"
                    onChange={(ev, { value }) => {
                      setZipCode(value);
                    }}
                    onBlur={() => {
                      setDisplayZipCodeError((!zipCode || zipCode.length < 5));
                    }}
                  />
                  {displayZipCodeError && (
                    <Message size="mini" negative={true}>Le code postal n'est pas valide (doit être composé de 5 caractères numériques).</Message>
                  )}
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field required>
                  <label>Adresse email</label>
                  <Input value={email} key="email"
                    onChange={(ev, { value }) => { setEmail(value); }}
                    onBlur={() => {
                      setDisplayEmailError(!emailIsValid);
                    }} />
                  {displayEmailError && (
                    <Message size="mini" negative={true}>Email invalide</Message>
                  )}
                </Form.Field>
                <Form.Field required>
                  <label>Vérification adresse email</label>
                  <Input value={verificationEmail} key="emailVerification"
                    onChange={(ev, { value }) => { setVerificationEmail(value); }}
                    onBlur={() => {
                      setDisplayVerificationEmailError(email !== verificationEmail);
                    }} />
                  {displayVerificationEmailError && (
                    <Message size="mini" negative={true}>L'email de confirmation doit être le même que l'email.</Message>
                  )}
                </Form.Field>
                <Form.Field>
                  <label>Téléphone (facultatif)</label>
                  <Input value={phoneNumber} key="phoneNumber" onChange={(ev, { value }) => { setPhoneNumber(value); }} />
                </Form.Field>
              </Form.Group>
              <p>Veuillez bien vérifier votre adresse email, celle-ci est importante car votre attestation de réservation et votre reçu de paiement y seront envoyés.</p>
              <Grid>
                <Grid.Row columns="2">
                  <Grid.Column>
                  </Grid.Column>
                  <Grid.Column textAlign="right">
                    <Button size='medium' color='green' icon labelPosition='right' onClick={() => { setStep(2); executeScroll(); }} disabled={step2IsValid === false}><Icon name='payment' /> Etape suivante</Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Form>
          </React.Fragment>
        )}
        {step === 2 && selectedEvent && (
          <React.Fragment>
            <Table celled striped unstackable>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan='3'>Votre réservation pour l'animation "{specialEventCategory.title}" le <b>{dayjs(selectedEvent.start).format('DD/MM/YYYY')}</b></Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell><b>Total</b></Table.Cell>
                  <Table.Cell></Table.Cell>
                  <Table.Cell collapsing textAlign='right'><b>{specialEventCategory.unitPrice * seats} &euro;</b></Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            <Segment>
              <Checkbox
                label='En cochant cette case, je reconnais avoir pris connaissance et accepté les conditions générales de vente : '
                onChange={() => setValidatedCGV(!validatedCGV)}
                checked={validatedCGV}
              />
              &nbsp;<b><a href={specialEventCategory.cgvUrl ? specialEventCategory.cgvUrl : "/wp-content/app/docs/Conditions générales de vente -Prestations visite de la ferme.pdf"} target="_blank" rel="noopener noreferrer" title="Consulter les conditions de vente">consulter les CGV</a></b>.<br />
              En cliquant sur "Procéder au paiement", vous serez redirigé vers le site de paiement sécurisé en ligne afin de finaliser votre achat.
            </Segment>
            <Grid>
              <Grid.Row columns="2">
                <Grid.Column>
                  <Button size='small' icon labelPosition='left' onClick={() => { setStep(1); executeScroll(); }} disabled={proceedingToPayment}><Icon name='arrow left' /> Etape précédente</Button>
                </Grid.Column>
                <Grid.Column textAlign="right">
                  <Button size="medium" color='green' icon labelPosition='right' loading={proceedingToPayment} disabled={(!validatedCGV || proceedingToPayment)} onClick={proceedToPayment}><Icon name='credit card' /> Procéder au paiement</Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            {proceedingToPayment && (
              <Segment textAlign='center'>
                <Loader active inline size='small' />
                Veuillez patienter, vous allez être redirigé sur le site de paiement Stripe...
              </Segment>)
            }
          </React.Fragment>
        )}
        {step === 3 && (
          <React.Fragment>
            <p>Votre numéro de réservation est <b>{bookingId}</b>.<br />Vous allez recevoir un email récapitulatif avec l'attestation de réservation de la part de <b>reservations@fermerainbow.com</b> à présenter à l'accueil lors de votre visite, ainsi qu'un deuxième avec votre reçu de paiement de la part de <b>support@stripe.com</b>. Vérifiez-bien que votre boite de messagerie ne les a pas bloqués.</p>
            <p style={{ textAlign: "center" }}><img src={`/api/qrcode/${bookingId}`} alt="" width="300" height="300" /></p>
            <p className="noprint">Vous pouvez sauvegarder cette page, celle-ci pourra servir d'attestation en cas d'email non reçu.</p>
            <p className="noprint"><Button onClick={() => { document.location.assign('/') }} color="green">Retourner à l'accueil du site</Button></p>
          </React.Fragment>
        )}
        {step === 4 && (
          <React.Fragment>
            <p>Vous avez annulé la commande ou un problème est survenu.</p>
            <p><Button as={NavLink} to="/" color="green" exact>Retourner à l'accueil du site</Button> <Button as={NavLink} to="/billetterie" color="green" exact>Retenter la réservation</Button></p>
          </React.Fragment>
        )}
        <Message negative={true} hidden={!errorMessage}>{errorMessage}</Message>
      </>)}
      {!specialEventCategory && (
        <Segment textAlign='center'>
          <Loader active inline size='small' />
        </Segment>
      )}
    </Container>
  );
}

export default ReservationEvenementSpecial;
